import { render } from "./DashboardExpenseTab.vue?vue&type=template&id=61884e7a&scoped=true"
import script from "./DashboardExpenseTab.vue?vue&type=script&lang=js"
export * from "./DashboardExpenseTab.vue?vue&type=script&lang=js"

import "./DashboardExpenseTab.vue?vue&type=style&index=0&id=61884e7a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61884e7a"]])

export default __exports__